import { InputNumber, Row, Space, Tag, Tooltip, Spin } from "antd";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import { DeleteForeverRounded, SouthWestRounded, SportsScoreRounded } from "@mui/icons-material";
import TickerChip from "../../../../components/TickerChip";
import React, { useState } from "react";
import { debounce } from "lodash";

const EtfItem = ({ symbol, item, updateEtfWeight, removeEtf, toggleReplicateEtf, minWeightTolerance, contribution }) => {
    const [loading, setLoading] = useState(false); // Local loading state
    const isWithinTolerance = contribution >= minWeightTolerance * 0.01;
    const doNotReplicate = item.doNotReplicate;
    const flagEtf = !isWithinTolerance && !doNotReplicate;
    const color = !flagEtf ? 'rgba(0,0,0,0.8)' : 'var(--red)';
    const fontWeight = flagEtf ? 'normal' : 'bold';
    const assetClass = item?.tags?.asset_class ?? '';

    console.log(item);
    console.log(contribution);

    let tooltipString = "";
    let background = 'transparent';

    if (assetClass !== 'equity') {
        background = 'var(--warning)';
        tooltipString += `${symbol.toUpperCase()} has large concentration to asset class ${assetClass.toUpperCase()}. This may cause problems in replicating the ETF.`;
    }

    let border = 'transparent';
    if (flagEtf) {
        border = '1px dashed var(--red)';
    } else if (doNotReplicate) {
        border = '1px dashed var(--primary)';
    } else if (assetClass !== 'equity') {
        border = '1px dashed var(--warning-dark)';
    }

    // Debounced callback to handle weight update
    const handleWeightChange = (value) => {
        setLoading(true); // Show spinner
        updateEtfWeight(symbol, value); // Call the debounced function
        setLoading(false); // Hide spinner
    };

    return (
        <Tooltip title={tooltipString}>
            <div className={'p-1'} key={symbol} style={{ border, background, borderRadius: '6px' }}>
                <div style={{ width: 240 }}>
                    <Row justify={'start'} align={'middle'}>
                        <ButtonGroup>
                            <Button onClick={() => toggleReplicateEtf(symbol, !doNotReplicate)}
                                color={item.doNotReplicate ? 'error' : 'primary'}
                                variant={'text'}
                                size={'small'}
                            >
                                <Tooltip title={doNotReplicate ? "Bring ETF Into Stock Replication" : "Flag this ETF to exclude it from stock replication"}>
                                    {doNotReplicate ? <SouthWestRounded fontSize={'small'} style={{ color: 'green' }} /> : <SportsScoreRounded fontSize={'small'} />}
                                </Tooltip>
                            </Button>
                            <Button variant={'text'} onClick={() => removeEtf(item)}><DeleteForeverRounded fontSize={'small'} /></Button>
                        </ButtonGroup>

                        {/* Spinner during loading */}
                        {loading ? (
                            <Spin size="small" />
                        ) : (
                            <InputNumber
                                width={80}
                                min={0}  // Ensure the weight is non-negative
                                max={100}  // Assume max weight is 100 (or adjust as needed)
                                value={item.weight * 100}  // Current weight
                                onChange={handleWeightChange}  // Use the debounced version
                                size={'small'}
                                style={{ width: 50 }}
                            />
                        )}
                        <Tag bordered={false} style={{ background: 'transparent', color, fontWeight }}>
                            {`${(contribution*100).toFixed(2) || 0}%`} {/* Updated to a fixed percentage format */}
                        </Tag>
                    </Row>

                    <TickerChip ticker={{ ...item, symbol: `${symbol} (${item?.holdings?.length})` }}
                        fontColor={color}
                        titleSize={'12px'}
                        textSize={'10px'}
                        width={240}
                    />
                </div>
            </div>
        </Tooltip>
    );
};

const EtfController = ({ etfs, etfContributions, updateEtfWeight, removeEtf, toggleReplicateEtf, minWeightTolerance = 0,
    wrap = true, sort = true }) => {
    // Create a debounced version of the updateEtfWeight function
    const debouncedUpdateWeight = debounce((symbol, value) => {
        updateEtfWeight(symbol, value);
    }, 1000); // 1000ms = 1 second delay

    const sortedEtfKeys = sort ? Object.keys(etfs).sort((a, b) => etfs[b].weight - etfs[a].weight) : Object.keys(etfs);

    return (
        <Space wrap={wrap} style={{ width: '100%', overflowX: 'scroll' }}>
            {sortedEtfKeys.map((item, index) => (
                <EtfItem key={item} symbol={item} item={etfs[item]} contribution={etfContributions[item]}
                    updateEtfWeight={debouncedUpdateWeight} removeEtf={removeEtf}
                    toggleReplicateEtf={toggleReplicateEtf} minWeightTolerance={minWeightTolerance}
                />
            ))}
        </Space>
    );
};

export default EtfController;
